import { render, staticRenderFns } from "./ApplicationsListTour.vue?vue&type=template&id=6a227e1c&scoped=true&"
import script from "./ApplicationsListTour.vue?vue&type=script&lang=js&"
export * from "./ApplicationsListTour.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationsListTour.vue?vue&type=style&index=0&id=6a227e1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a227e1c",
  null
  
)

export default component.exports